import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const sharedData: Pick<LocDef, 'feature' | 'type' | 'portal' | 'htmlAllowed' | 'shared'> = {
	feature: HubFeature.CredentialAgreement,
	portal: 'CP',
	htmlAllowed: false,
	shared: false,
};

const dpRoot = 'Credentials|Agreement';

export type CpLatestAgreementModalLocs =
	| 'CPLatestAgreementModalTitle'
	| 'CPLatestAgreementModalCloseButton';
export type CpLatestAgreementModalLocsType = LocMap<CpLatestAgreementModalLocs>;

export const cpLatestAgreementModalLocs: LocDefs<CpLatestAgreementModalLocs> = {
	CPLatestAgreementModalTitle: {
		...sharedData,
		defaultValue: 'Latest Agreement',
		displayPath: `${dpRoot}|Latest Agreement Modal|Title`,
		description: 'Title for the latest agreement modal dialog.',
		legacyName: 'Credential.Agreement/Credentials.Agreement.Title.LatestAgreement',
		displayType: 'Title',
	},
	CPLatestAgreementModalCloseButton: {
		...sharedData,
		defaultValue: 'Close',
		displayPath: `${dpRoot}|Latest Agreement Modal|Close Button`,
		description: 'Text for the close button in the latest agreement modal.',
		legacyName: 'Credential.Agreement/Credentials.Agreement.Button.CloseLatestAgreement',
		displayType: 'Button',
	},
};

export const CpLatestAgreementModalLocs = MapLocKeys<CpLatestAgreementModalLocs>(
	cpLatestAgreementModalLocs
);
